import { currRoute } from '@/utils/index'

export class RouterOptions<T> {
  static options:
    | null
    | UniNamespace.NavigateToOptions
    | UniNamespace.RedirectToOptions
    | UniNamespace.ReLaunchOptions = null
}

const Router = {
  // 获取当前页面
  currRoute,
  // 保留当前页面，跳转到应用内的某个页面，使用uni.navigateBack可以返回到原页面。
  navigateTo: () => {
    if (currRoute().path === RouterOptions.options?.url) return
    uni.navigateTo(RouterOptions.options)
    Router.clearOption()
  },
  // 关闭当前页面，跳转到应用内的某个页面。
  redirectTo: () => {
    if (currRoute().path === RouterOptions.options?.url) return
    uni.redirectTo(RouterOptions.options)
    Router.clearOption()
  },
  // 关闭所有页面，打开到应用内的某个页面
  reLaunch: () => {
    if (currRoute().path === RouterOptions.options?.url) return
    uni.reLaunch(RouterOptions.options)
    Router.clearOption()
  },
  // 跳转到 tabBar 页面，并关闭其他所有非 tabBar 页面。
  switchTab: (url: string, complete?: () => void) => {
    uni.switchTab({
      url,
      complete: complete && complete(),
    })
    Router.clearOption()
  },
  // 关闭当前页面，返回上一页面或多级页面
  navigateBack: (options?: UniNamespace.NavigateBackOptions) => {
    const pages = getCurrentPages()
    if (pages.length > 1) {
      // 如果有上一级页面，正常返回
      uni.navigateBack(options || { delta: 1 })
    } else {
      // 如果没有上一级页面，跳转到首页
      uni.reLaunch(
        options || {
          url: '/pages/index/index', // 你的首页路径
        },
      )
    }
    Router.clearOption()
  },
  clearOption: () => {
    nextTick(() => {
      RouterOptions.options = null
    })
  },
}

export default Router
